<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
export default {
  components: {
    datePicker
  },
  extends: datePicker,
  props: {
    value: {
      default: null,
      required: true,
      validator (value) {
        return value === null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof moment
      }
    }
  },
  watch : {
    value: function (value) {
      if (value instanceof moment) {
        this.$emit('input', value.format(this.dp.format()))
      }
    },

  },
  mounted () {
    this.dp.date(this.value)
  },

}
</script>

<style>
body .datepicker table {
  width:100%;
}
</style>
